<div style="font-size: 16px !important">
    @if(entry === 'providerEnrollment' && isProcessed && !isViewTimeOff){
    <div style="width: 50%; display: flex; font-size: 16px; margin:24px;">
        <p style="width: 100%;">
            Select Participant:
        </p>
        <nz-select [(ngModel)]="consumer" class="ppl-select" id="consumer" nzPlaceHolder="Select Participant"
            (ngModelChange)="consumerValueChange($event)" nzShowSearch nzAllowClear>
            @for(opt of consumers; track $index){
            <nz-option [nzLabel]="opt.consumerFullName" [nzValue]="opt"></nz-option>
            }
        </nz-select>
    </div>
    }

    @if(showTimesheets){

    @if(entry === 'providerEnrollment'){
    <nz-divider></nz-divider>
    <div nz-row class="mt-2 provider-section">
        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600" ngClass="pt-1 pb-2">
                    Participant Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{consumerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600" ngClass="pt-1 pb-2">
                    Participant PPL ID:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{consumerPPLId}}</div>
            </div>
        </div>
    </div>

    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="TSdata"
        (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)" [disableSelection]="true"
        [cols]="cols" [gridTitle]="false" [timesheetFor]="'provider'" [pagination]="false" [showLineItem]="true"
        [loadPage]="true">
    </ppl-list-table>

    }
    }

    @if(entry === 'participantEnrollment'){
    <nz-divider></nz-divider>
    <div nz-row class="mt-2 provider-section">
        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600" ngClass="pt-1 pb-2">
                    Provider Name:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{providerName}}</div>
            </div>
        </div>

        <div nz-col nzSpan="24" class="mt-1">
            <div nz-row>
                <div nz-col nzSpan="8" class="font-weight-600" ngClass="pt-1 pb-2">
                    Provider PPL ID:
                </div>
                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{providerPplId}}</div>
            </div>
        </div>
    </div>

    @if(!isProcessed && !isReadOnly){
    <div class="custom-row">
        <div class="mr-2">
            <!-- *authorize="[pageId, tabId, 'approvePayroll', 'button']" -->
            <ppl-button label="Approve" (click)="approvePayroll()" [customClass]="'ghost-button'"
                [iconPosition]="'left'"></ppl-button>
        </div>

        <div class="mr-2">
            <ppl-button label="Deny" (click)="denyPayroll()" [customClass]="'ghost-button'"
                [iconPosition]="'left'"></ppl-button>
        </div>
    </div>
    }
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="viewConsumerLineData"
        (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)"
        (selectionChanged)="selectionChanged($event)" [disableSelection]="isProcessed" [cols]="consumer_cols"
        [gridTitle]="false" [pagination]="false" [showExpandIcon]="true" [showLineItem]="true"
        [lineItemCols]="consumer_cols" [showLineItemActions]="false" [cellClassResolver]="cellClassResolver"
        [additionalCols]="additionalCols"
        [timesheetFor]="'consumer'" (showAuthDetails)="showAuthDetails($event)" [loadPage]="true">
    </ppl-list-table>

    }

    @if(entry === 'providerEnrollment' && isViewTimeOff){
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="!isReadOnly" [data]="timeoffData"
        (rowDetailEventTs)="rowClickedTs($event)" (rowDetailEvent)="rowClicked($event)" [disableSelection]="true" [actionButtons]="actionButtons"
        [cols]="timeoff_cols" [gridTitle]="false" [pagination]="true" [showLineItem]="true" [loadPage]="false"
        (gridAction)="action($event)">
    </ppl-list-table>
    }
</div>

<div class="filter-panel">
    <ng-template #denyDialog let-cancel="cancel">
        <p>Reason: </p>
        <nz-select nzPlaceHolder="Select Reason" [(ngModel)]="selectedReason" style="width:100%; margin-bottom: 16px"
            nzShowArrow>
            @for(item of listOfOption; track $index ){
            <nz-option [nzLabel]="item" [nzValue]="item"></nz-option>
            }
        </nz-select>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p>Are you sure you want to remove this entry?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'timesheet'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDataDialog let-cancel="cancel">
        <ppl-timesheet-staff-authdata [authData]="authData"
            (showAuthDetails)="showAuthDetails($event)"></ppl-timesheet-staff-authdata>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
            [disabled]="true"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #deniedDialog let-cancel="cancel">
        <ppl-timesheet-staff-deniedreasons [deniedData]="deniedData"></ppl-timesheet-staff-deniedreasons>
    </ng-template>
</div>